export const DAILY_REPORT_REQUESTING = 'dailyReport/DAILY_REPORT_REQUESTING';
export const DAILY_REPORT_SUCCESS = 'dailyReport/DAILY_REPORT_SUCCESS';
export const DAILY_REPORT_ERROR = 'dailyReport/DAILY_REPORT_ERROR';
export const LOAD_TOTAL_REPORT = 'dailyReport/LOAD_TOTAL_REPORT';
export const TOTAL_DAILY_REPORT = 'dailyReport/TOTAL_DAILY_REPORT';
